<template>
  <div class="vertical-fill">
    <div class="title">
      {{ $t('view-Register-verify.title') }}
    </div>
    <div class="text-center">
      <b-spinner />
    </div>
    <div />
  </div>
</template>

<script>
export default {
  created () {
    const hash = this.$route.params.hash
    this.$store.dispatch('user/registerVerify', hash)
      .then((result) => {
        this.$flash.success(this.$t('view-Register-verify.message.success'))
        this.$flash.info(this.$t('view-Register-verify.message.reg-info'))
        // google tag manager custom event
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'register-confirmed', email: result.email })
        }
        this.$router.push({ name: 'login' })
      })
      .catch((e) => {
        if (e.response.status === 410) {
          this.$flash.error(this.$t(e.response.body.error))
        } else {
          this.$flash.error(this.$t('view-Register-verify.message.error'))
        }
        this.$router.push({ name: 'login' })
      })
  }
}
</script>
